import type { StepRenderProps } from "./types";
import type { EmailStep as EmailStepConfig } from "@/types/offer";

export function EmailStep({ step, value, onChange, autoFocus, error }: StepRenderProps<EmailStepConfig>) {
  return (
    <input
      type="email"
      inputMode="email"
      autoComplete="email"
      className="r1-field"
      autoFocus={autoFocus}
      placeholder={step.placeholder ?? "you@company.com"}
      value={typeof value === "string" ? value : ""}
      onChange={(e) => onChange(e.target.value)}
      aria-invalid={!!error}
      aria-label={step.title}
    />
  );
}
